import Button from '@components/Button';
import PaymentForm from '../../partials/form/PaymentForm';
import Alert from '@material-ui/lab/Alert';

const ContentStep2 = (props) => {
  const reserve = props.reserve;

  // Pagamento já registrado via orçamento — exibe resumo somente leitura
  const presalePaid = reserve.from_presale === true;

  const idDisabled = () => {
    if (props.loading) return true;
    // Presale: comprovante já vem anexado automaticamente
    if (presalePaid) return false;
    // Venda pendente: libera sem exigir comprovante
    if (reserve.payment_status === "pending") return false;
    // Venda realizada: exige método, tipo e pelo menos 1 comprovante
    if (reserve.payment_status === "accomplished" && reserve.payment_type !== null && reserve.payment_method !== null && reserve.proofs.length > 0) return false;
    return true;
  };

  const methodLabel = reserve.payment_method === 'pix' ? '⚡ PIX' : reserve.payment_method === 'credit_card' ? '💳 Cartão de crédito' : reserve.payment_method;
  const statusLabel = reserve.payment_type === 'partial' ? 'Parcial (entrada)' : 'Total';

  return <>
    <div className="mt-4 bg-white text-blue font-poppins" style={{ borderRadius: '10px' }}>
      {presalePaid ? (
        <div style={{ padding: '20px 24px' }}>
          <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 16, color: '#1e3a5f' }}>
            ✅ Pagamento registrado pelo cliente
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
            <tbody>
              <tr style={{ borderBottom: '1px solid #e0e7ef' }}>
                <td style={{ padding: '10px 0', color: '#64748b' }}>Forma de pagamento</td>
                <td style={{ padding: '10px 0', fontWeight: 600 }}>{methodLabel}</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #e0e7ef' }}>
                <td style={{ padding: '10px 0', color: '#64748b' }}>Status</td>
                <td style={{ padding: '10px 0', fontWeight: 600 }}>{statusLabel}</td>
              </tr>
              <tr style={{ borderBottom: '1px solid #e0e7ef' }}>
                <td style={{ padding: '10px 0', color: '#64748b' }}>Valor pago</td>
                <td style={{ padding: '10px 0', fontWeight: 700, color: '#16a34a' }}>
                  R$ {Number(reserve.customer_paid_amount).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </td>
              </tr>
              {reserve.payment_status === 'partial' && (
                <tr>
                  <td style={{ padding: '10px 0', color: '#64748b' }}>Comprovante</td>
                  <td style={{ padding: '10px 0', color: '#64748b', fontSize: 12 }}>Anexado automaticamente via Asaas</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <PaymentForm
          reserve={reserve}
          changeReserve={props.changeReserve}
          addProof={props.addProof}
          removeProofPayment={props.removeProof}
        />
      )}
    </div>
    {/* Fix (2026-09-17): botão ficava desabilitado sem nenhum aviso quando faltava
        anexar comprovante (venda "Realizado" exige método + tipo + comprovante),
        e o Button.jsx não mudava de cor quando disabled — parecia clicável mas não
        fazia nada. Corrigido o visual do botão (agora fica cinza de verdade) e
        adicionado esse aviso explicando o motivo. */}
    {!presalePaid && reserve.payment_status === 'accomplished' && reserve.proofs.length === 0 && (
      <Alert className="mb-4" variant="filled" severity="warning">
        É necessário anexar um comprovante.
      </Alert>
    )}
    <div className="flex justify-end mb-4 space-x-5">
      <Button
        textcolor="#e8f0fb"
        padding="6px 15px"
        width="100px"
        variant="outlined"
        onClick={() => props.changeStep(1)}
        bgColor="transparent"
      >
        Voltar
      </Button>
      <Button
        disabled={idDisabled()}
        textcolor="#fff"
        padding="6px 15px"
        width="200px"
        onClick={() => props.create()}
        customcolor={props.theme.color}
      >
        Finalizar reserva
      </Button>
    </div>
  </>
}

export default ContentStep2;

